module.exports = __webpack_public_path__ + "static/media/howToPlay1.999f9faf.png";